import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var scrollGutterPluginKey = new PluginKey('scrollGutter');
export var getScrollGutterPluginState = function getScrollGutterPluginState(state) {
  if (state) {
    return scrollGutterPluginKey.getState(state);
  }
};